export const legacyLoginTheme = {
  heroImage: "",
  loginLogo: "",
  heading1Text: "",
  heading2Text: "",
  heading3Text: "",
  headingsColor: "#000000",
  rightHeadingColor: "#000000",
  rightPanelTextColor: "#000000",
  rightInputTextColor: "#000000",
  formBackgroundColor: "#ffffff",
  loginButtonTextColor: "#ffffff",
  loginButtonActiveBgColor: "#000000",
  loginButtonDisabledBgColor: "rgb(170 170 170)",
  loginButtonTextDisabledColor: "rgb(255 255 255)",
  template: "", // Use empty string to trigger legacy layout
};

export const buildLoginTheme = (companyDetails) => {
  const theme = companyDetails?.theme || {};
  const loginThemeFromBackend = theme?.loginTheme || {};

  if (
    !loginThemeFromBackend?.template ||
    loginThemeFromBackend?.defaultTheme !== false
  ) {
    return legacyLoginTheme;
  }

  // Custom default theme off + template — merge backend over legacy defaults
  return {
    ...legacyLoginTheme,
    ...loginThemeFromBackend,
  };
};

export const buildLoginCssVars = (theme) => ({
  "--login-bg": theme.formBackgroundColor,
  "--login-text": theme.rightPanelTextColor,
  "--login-heading": theme.headingsColor,
  "--login-right-bg": theme.formBackgroundColor,
  "--login-right-text": theme.rightPanelTextColor,
  "--login-right-heading": theme.rightHeadingColor,
  "--login-right-body": theme.rightPanelTextColor,
  "--login-right-input-text": theme.rightInputTextColor,
  "--login-button": theme.loginButtonActiveBgColor,
  "--login-button-text": theme.loginButtonTextColor,
  "--login-button-disabled": theme.loginButtonDisabledBgColor,
  "--login-button-disabled-text": theme.loginButtonTextDisabledColor,
});

export const getSupportText = (theme) =>
  theme?.supportText ||
  "Need help? Reach out to your recruiter for assistance.";


